import * as React from 'react';
import {useDispatch} from 'react-redux';

import {Button} from 'shells/button/button';

import type {GetMcfxForms_mcfxForms_edges_node_wfForm_publishedVersion_fields as Field} from 'nutshell-graphql-types';

import type {FormFieldSchema} from '../../../core/nutshell-fields/types';
import {useGetLimitsByType, openModalForType} from '../../../limits';

import {useActivateForm} from '../use-activate-form';

import {ActivateFormModal} from './activate-form-modal';

type Props = {
    formId: string;
    fields: Field[];
    formSchema: FormFieldSchema;
};

export function ActivateFormButton(props: Props) {
    const dispatch = useDispatch();
    const activateForm = useActivateForm();
    const [isActivatingForm, setIsActivatingForm] = React.useState<boolean>(false);
    const {limits} = useGetLimitsByType('FORMS');

    const handleClickActivateForm = React.useCallback(() => {
        if (limits && limits.canAdd) {
            setIsActivatingForm(true);
        } else {
            dispatch(openModalForType('FORMS'));
        }
    }, [setIsActivatingForm, dispatch, limits]);

    return (
        <>
            <Button variant='primary' size='big' onClick={handleClickActivateForm}>
                Activate form
            </Button>
            {isActivatingForm ? (
                <ActivateFormModal
                    fields={props.fields}
                    onClose={() => setIsActivatingForm(false)}
                    onActivateForm={() => activateForm({wfFormId: props.formId})}
                    formSchema={props.formSchema}
                />
            ) : undefined}
        </>
    );
}
